import type { MailboxInfo, AccountKey } from "owa-client-types";
import { getAccountKeyForMailboxInfo } from "owa-client-types";
import { logCoreUsage } from "owa-analytics";
import type { CopilotEnablementDiagnostics } from "owa-copilot-settings-store/lib/utils/enablementCodes/CopilotEnablementTypes";

// Map to track diagnostics codes that have been logged for each mailbox
const loggedDiagnosticsByMailbox = new Map<AccountKey, string | undefined>();

/**
 * Logs BizchatSidepaneEnablementDiagnostics telemetry when the diagnostics code changes
 * @param mailboxInfo The mailbox to log for
 * @param diagnostics The diagnostics to log
 */
export function logBizchatSidepaneEnablementDiagnostics(mailboxInfo: MailboxInfo, diagnostics: CopilotEnablementDiagnostics, cohort?: string): void {
    const accountKey = getAccountKeyForMailboxInfo(mailboxInfo);
    const currentDiagnosticsCode = diagnostics.code;
    
    // Only log if we haven't logged for this mailbox yet, or if the diagnostics code has changed
    const previousDiagnosticsCode = loggedDiagnosticsByMailbox.get(accountKey);
    if (!loggedDiagnosticsByMailbox.has(accountKey) ||
        (previousDiagnosticsCode &&
            currentDiagnosticsCode &&
            previousDiagnosticsCode !== currentDiagnosticsCode)) {
        loggedDiagnosticsByMailbox.set(accountKey, currentDiagnosticsCode);
        
        logCoreUsage("BizchatSidepaneEnablementDiagnostics", mailboxInfo, {
            enablementDiagnostics: currentDiagnosticsCode,
            userCohort: cohort,
        });
    }
}
